import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { DaliService } from '@dali/tagger-ng8';
import { EVENT as EVENT_FA_TC, PAGEVIEW as PAGEVIEW_FA, CHANNEL as CHANNEL_FA, COUNTRY as COUNTRY_FA, BUSINNESS as BUSINNESS_FA, ENVIRONMENT as ENVIRONMENT_FA, FAMILY as FAMILY_FA, SUBFAMILY as SUBFAMILY_FA, PRODUCT as PRODUCT_FA, } from 'src/app/shared/constants/dali-fa-tc.constants';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';
import { ChannelCommunicatorService } from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';
import { FirmlyApprovedService } from 'src/app/shared/services/firmly-approved/firmly-approved.service';
var SELECTED_FRANCHISE = 'selectedFranchise';
var VirtualCardFranchiseComponent = /** @class */ (function () {
    function VirtualCardFranchiseComponent(copyService, headerService, abrecuentasService, bitacoraService, navigationService, firmlyApprovedService, channelCommunicatorService, taggingService, daliService) {
        this.copyService = copyService;
        this.headerService = headerService;
        this.abrecuentasService = abrecuentasService;
        this.bitacoraService = bitacoraService;
        this.navigationService = navigationService;
        this.firmlyApprovedService = firmlyApprovedService;
        this.channelCommunicatorService = channelCommunicatorService;
        this.taggingService = taggingService;
        this.daliService = daliService;
        this.enableButtonNext = false;
        this.virtualCardFranchiseModel = {
            selectedFranchise: {},
        };
        this.headerService.show(true, true, true);
    }
    VirtualCardFranchiseComponent.prototype.ngOnInit = function () {
        if (this.taggingService.isFirmlyAprovedMono()) {
            this.sendVirtualFranchisePageLoad();
        }
        this.setVirtualCardFranchiseModel();
    };
    VirtualCardFranchiseComponent.prototype.setVirtualCardFranchiseModel = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.abrecuentasService.getVirtualCardFranchise()];
                    case 1:
                        _a.virtualCardFranchiseModel = _b.sent();
                        this.getListProducts();
                        this.radioValidation();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Obtiene la lista de productos para el radio options
     */
    VirtualCardFranchiseComponent.prototype.getListProducts = function () {
        var _this = this;
        this.listProducts = this.abrecuentasService.getPayDayProductSelected().selectedProduct
            .map(function (p) { return (tslib_1.__assign({}, p, { checked: (_this.virtualCardFranchiseModel.selectedFranchise
                && p.elementId === _this.virtualCardFranchiseModel.selectedFranchise.elementId) ? true : false })); });
        this.listProducts.sort(function (p) { return p.elementId; });
        this.listProducts.find(function (p) { return p.checked; })
            ? this.enableButtonNext = true
            : this.virtualCardFranchiseModel[SELECTED_FRANCHISE] = null;
    };
    /**
     * asigna el valor del radio option seleccionado al objeto vistualCardFranchiseModel de persistencia en el flujo
     * llama a la función encargada de actualizar el servicio que controla la infromación de los radio
     * llama a la funcion encargada de validar el valor de los radio para habilitar el boton next
     * @param event
     * @param index
     */
    VirtualCardFranchiseComponent.prototype.onRadioChange = function (event) {
        event.value.checked = true;
        this.virtualCardFranchiseModel[SELECTED_FRANCHISE] = event.value;
        this.updateVirtualCardFranchiseInService();
        this.radioValidation();
    };
    /**
     * Valida el objeto virtualCardfranchiseModel, para habilitar el boton next
     */
    VirtualCardFranchiseComponent.prototype.radioValidation = function () {
        this.enableButtonNext = !!(this.virtualCardFranchiseModel[SELECTED_FRANCHISE]);
    };
    /**
     * Actualiza en el servicio los valores de virtualCardFranchiseModel
     */
    VirtualCardFranchiseComponent.prototype.updateVirtualCardFranchiseInService = function () {
        if (this.virtualCardFranchiseModel && this.virtualCardFranchiseModel.selectedFranchise) {
            this.abrecuentasService.setVirtualCardFranchise(this.virtualCardFranchiseModel);
        }
    };
    /**
     * update selected options to global model and redirecct next view
     *
     * @memberof VirtualCardFranchiseComponent
     */
    VirtualCardFranchiseComponent.prototype.next = function () {
        this.sendContinueButtonEvent();
        this.updateVirtualCardFranchiseInService();
        var bitacoraEvent = "product_datavirtualcard_" + this.virtualCardFranchiseModel[SELECTED_FRANCHISE].label;
        this.bitacoraService.saveDataInBitacora(bitacoraEvent);
        if (this.abrecuentasService.viewOptionMultiProduct) {
            this.navigationService.nextStep(this.navigationService.nextMulti(this.abrecuentasService.getProductsSelects()));
        }
        else {
            this.navigationService.nextStep();
        }
    };
    /* ------------- Taggeo ------------- */
    /* ------------ Taggeo - PageLoad ------------ */
    VirtualCardFranchiseComponent.prototype.sendVirtualFranchisePageLoad = function () {
        var isApp = this.channelCommunicatorService.getChannelId() === '141';
        var changes = [
            {
                path: PAGEVIEW_FA.pv11pageName.path,
                value: (isApp ? CHANNEL_FA.superapp : CHANNEL_FA.homeBanking) + ":" + COUNTRY_FA.co + ":" + BUSINNESS_FA.pf + ":" + ENVIRONMENT_FA.loggeado + ":" + FAMILY_FA.services + ":" + SUBFAMILY_FA.request + ":" + PRODUCT_FA.request + ":" + PAGEVIEW_FA.pv11pageName.value,
            },
            {
                path: PAGEVIEW_FA.pv11pageFamily.path,
                value: PAGEVIEW_FA.pv11pageFamily.value,
            },
            {
                path: PAGEVIEW_FA.pv11subFamily.path,
                value: PAGEVIEW_FA.pv11subFamily.value,
            },
            {
                path: PAGEVIEW_FA.pv11pageAction.path,
                value: PAGEVIEW_FA.pv11pageAction.value,
            },
            {
                path: PAGEVIEW_FA.pv11pageid.path,
                value: VirtualCardFranchiseComponent.name,
            },
            {
                path: PAGEVIEW_FA.pv11transactionName.path,
                value: PAGEVIEW_FA.pv11transactionName.value,
            },
            {
                path: PAGEVIEW_FA.pv11transactionTransactionStep.path,
                value: PAGEVIEW_FA.pv11transactionTransactionStep.value,
            },
        ];
        this.taggingService.addCommonPageChanges(changes);
        this.daliService.pageLoad(changes);
    };
    /* -------------- Taggeo - Events ------------- */
    VirtualCardFranchiseComponent.prototype.sendBackButtonEvent = function () {
        if (!this.taggingService.isFirmlyAprovedMono()) {
            return;
        }
        var data = [
            {
                path: EVENT_FA_TC.pv11E1setData.pv11E1transactionTransactionStep.path,
                value: EVENT_FA_TC.pv11E1setData.pv11E1transactionTransactionStep.value,
            },
            {
                path: EVENT_FA_TC.pv11E1setData.pv11E1transactionName.path,
                value: EVENT_FA_TC.pv11E1setData.pv11E1transactionName.value,
            },
        ];
        var event = {
            category: {
                module: EVENT_FA_TC.customCategory.module.body,
                type: EVENT_FA_TC.customCategory.type.button,
                position: EVENT_FA_TC.customCategory.position.center,
            },
            action: EVENT_FA_TC.customAction.click,
            label: EVENT_FA_TC.pv11E1customLabel,
        };
        this.daliService.trackEvent(event, data);
    };
    VirtualCardFranchiseComponent.prototype.sendContinueButtonEvent = function () {
        var data = [
            {
                path: EVENT_FA_TC.pv11E2setData.pv11E2transactionTransactionStep.path,
                value: EVENT_FA_TC.pv11E2setData.pv11E2transactionTransactionStep.value,
            },
            {
                path: EVENT_FA_TC.pv11E2setData.pv11E2transactionName.path,
                value: EVENT_FA_TC.pv11E2setData.pv11E2transactionName.value,
            },
        ];
        var event = {
            category: {
                module: EVENT_FA_TC.customCategory.module.body,
                type: EVENT_FA_TC.customCategory.type.button,
                position: EVENT_FA_TC.customCategory.position.center,
            },
            action: EVENT_FA_TC.customAction.click,
            label: EVENT_FA_TC.pv11E2customLabel,
        };
        this.daliService.trackEvent(event, data);
    };
    return VirtualCardFranchiseComponent;
}());
export { VirtualCardFranchiseComponent };
